import { render, staticRenderFns } from "./Projektmanagement.vue?vue&type=template&id=6df5c378&scoped=true&"
import script from "./Projektmanagement.vue?vue&type=script&lang=js&"
export * from "./Projektmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5c378",
  null
  
)

export default component.exports